/* import __COLOCATED_TEMPLATE__ from './success.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './success.module.scss';

@classic
@classNames(styles.component)
export default class SignInTokenStatesSuccess extends Component {}
